/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfOrder } from '../../models/data-page-of-order';

export interface OrderList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  orderClass?: string | null;
  pageNumber?: number;
  sortbydirection?: string | null;
}

export function orderList(http: HttpClient, rootUrl: string, params?: OrderList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfOrder>> {
  const rb = new RequestBuilder(rootUrl, orderList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('orderClass', params.orderClass, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfOrder>;
    })
  );
}

orderList.PATH = '/order/list';
